var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    color: "#333333",
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.761 14.7399C10.4935 13.4724 9.53799 12.0532 8.90315 10.6135C8.76882 10.3091 8.8479 9.95264 9.08299 9.71755L9.97024 8.83139C10.6972 8.10447 10.6972 7.07639 10.0623 6.44155L8.79049 5.16972C7.9444 4.32364 6.5729 4.32364 5.72682 5.16972L5.02049 5.87605C4.21774 6.6788 3.88299 7.83689 4.09965 8.98522C4.63482 11.816 6.27932 14.9154 8.9324 17.5685C11.5855 20.2216 14.6849 21.8661 17.5157 22.4012C18.664 22.6179 19.8221 22.2831 20.6248 21.4804L21.3301 20.7751C22.1762 19.9291 22.1762 18.5576 21.3301 17.7115L20.0593 16.4407C19.4245 15.8059 18.3953 15.8059 17.7616 16.4407L16.7833 17.4201C16.5482 17.6551 16.1918 17.7342 15.8874 17.5999C14.4477 16.964 13.0285 16.0074 11.761 14.7399Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIc);
export default __webpack_public_path__ + "static/media/phone_ic.f11274b5dcaaefbb93864b1f96951217.svg";
export { ForwardRef as ReactComponent };